import 'select2'
import 'select2/dist/js/i18n/de'
import shortid from 'shortid'

const selectLocation = ($select, data) => {
  const newOption = new Option(data.text, data.id, true, true)
  $select
    .append(newOption)
    .trigger('change')
    .trigger({
      type: 'select2:select',
      params: { data }
    })
}

$.fn.clientPicker = function (setPhoneNumber, $emailInput, $locationSelect2, $address2) {
  this.select2({
    minimumInputLength: 3,
    tags: true,
    ajax: {
      url: '/api/internal/search/clients',
      dataType: 'json',
      data: ({ term }) => ({ query: term }),
      delay: 500,
      processResults: (clients) => {
        const results = clients.map((client) => (
          Object.assign({
            id: client.customer_name,
            text: client.customer_name
          }, client)
        ))
        return { results }
      },
    },
    templateResult: (state) => {
      if (!state.id) {
        return state.text;
      }
      const { text, phone, location, address2, email } = state
      return $(
        '<div>' +
        text +
        (phone ? ('<div class="text-sm font-weight-lighter">' + phone + '</div>') : '') +
        (email ? ('<div class="text-sm font-weight-lighter">' + email + '</div>') : '') +
        (location ? ('<div class="text-sm font-weight-lighter">' + location.name + '</div>') : '') +
        (address2 ? ('<div class="text-sm font-weight-lighter">' + address2 + '</div>') : '') +
        '</div>'
      )
    }
  }).on('select2:select', (e) => {
    const { phone, location, address2, email } = e.params.data

    if (phone) {
      setPhoneNumber(phone)
    }

    if (email) {
      $emailInput.val(email)
    }

    if (location) {
      selectLocation(
        $locationSelect2,
        Object.assign({ id: shortid.generate(), text: location.name }, location)
      )
    }

    if (address2) {
      $address2.val(address2)
    }

    const event = new CustomEvent('client-select', {
      detail: {
        placeId: location?.address?.place_id
      }
    })
    window.dispatchEvent(event)
  })
  return this
}
